import { Navigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
  defaultPanelPath,
  getDefaultPanel,
  isIamAccessLoading,
  subscribeIamAccess,
} from './iamAccess';

function AccessLoadingShell() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6 text-foreground">
      <p className="text-sm text-text-tertiary">Loading your workspace…</p>
    </div>
  );
}

/** Redirect root and unknown paths to the user's default panel without loops. */
export function WorkspaceRedirect() {
  const location = useLocation();
  const [, setIamAccessRevision] = useState(0);

  useEffect(() => {
    return subscribeIamAccess(() => {
      setIamAccessRevision((revision) => revision + 1);
    });
  }, []);

  if (isIamAccessLoading()) {
    return <AccessLoadingShell />;
  }

  const target = defaultPanelPath();
  if (location.pathname === target) {
    if (getDefaultPanel() === 'none') {
      return <Navigate to="/access-denied" replace />;
    }
    return null;
  }

  return <Navigate to={target} replace />;
}
